export default __webpack_public_path__ + "static/media/en_route.7ace227e.svg";